import FieldSelectPanelField from '../FieldSelectPanelField';

import { Wrapper } from '@american-autonomy/ag-ui';

import EntitySelectPillButton from 'components/EntitySelectPillButton';
import WithField from 'components/WithField';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FieldValues, Props } from './types';

import styles from './styles.module.scss';

const SelectFieldField = <T extends FieldValues>(props: Props<T>) => {
    const {
        className = '',
        control,
        farmId,
        isOpen,
        isRequired,
        label,
        name,
        onPanelClose,
        onPanelOpen,
        placeholder,
        ref,
        testId = TEST_ID
    } = props;

    const { FIELD } = useTranslation();

    const { containerRef, handleClose, handleToggle, isPanelOpen, onChange, value } = useData<T>({
        control,
        farmId,
        isOpen,
        isRequired,
        name,
        onPanelClose,
        onPanelOpen,
        ref
    });

    const fieldLabel = label ?? FIELD;

    return (
        <Wrapper
            className={`${styles.wrapper} ${isPanelOpen ? styles.panelOpen : ''} ${className}`}
            ref={containerRef}
            testId={testId}>
            <WithField className={styles.withField} label={fieldLabel}>
                <EntitySelectPillButton
                    hasValue={!!value}
                    onClick={handleToggle}
                    onRemove={() => onChange(null)}
                    text={value?.label ?? placeholder ?? FIELD}
                />
            </WithField>

            {isPanelOpen && (
                <FieldSelectPanelField
                    farmId={farmId}
                    onChange={onChange}
                    onClose={handleClose}
                    value={value}
                />
            )}
        </Wrapper>
    );
};

export default SelectFieldField;
